import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft, Calendar, User } from "lucide-react";
import { Seo } from "../components/Seo";
import { POSTS } from "../data/site";

export default function BlogDetailPage() {
  const { slug } = useParams();
  const post = POSTS.find((p) => p.slug === slug);
  if (!post) return <Navigate to="/blog" replace />;

  return (
    <div data-testid="blog-detail-page">
      <Seo title={`${post.title} — IDEAL ENTERPRISES`} description={post.excerpt} />

      <section className="relative pt-32 pb-12 md:pt-40 md:pb-16 bg-brand-blue text-white">
        <div className="absolute inset-0">
          <img src={post.image} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-brand-blue/80 to-brand-blue" />
        </div>
        <div className="max-w-3xl mx-auto px-6 lg:px-10 relative">
          <Link to="/blog" data-testid="back-to-blog" className="inline-flex items-center gap-2 text-white/70 hover:text-brand-orange text-sm">
            <ArrowLeft size={14} /> All articles
          </Link>
          <p className="overline text-brand-orange mt-6">{post.category}</p>
          <h1 className="font-heading font-black text-4xl md:text-5xl mt-4 leading-tight">{post.title}</h1>
          <div className="mt-6 flex items-center gap-6 text-sm text-white/70 font-mono-tech">
            <span className="inline-flex items-center gap-2"><User size={14} />{post.author}</span>
            <span className="inline-flex items-center gap-2"><Calendar size={14} />{post.date}</span>
          </div>
        </div>
      </section>

      <article className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <div className="aspect-[16/9] overflow-hidden mb-10 -mt-24 border-4 border-white shadow-lg">
            <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
          </div>
          <div className="prose prose-slate max-w-none">
            {post.body.map((para, i) => (
              <p key={i} className="text-slate-700 leading-relaxed text-lg mt-5">{para}</p>
            ))}
          </div>
        </div>
      </article>
    </div>
  );
}
